import { Box, Typography, useTheme } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useIntl } from 'react-intl'

const TermsOfUseForm = ({ isLoading, onAccept, onExit, termsOfUse }: any) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  return (
    <Box sx={{ width: '100%', maxWidth: '720px', margin: '2rem auto', px: 2 }}>
      <Typography variant='h5' fontWeight='bold' mb={3}>
        {formatMessage({
          id: 'termsOfUse.terms',
          defaultMessage: 'Warunki korzystania z usługi'
        })}
      </Typography>
      <Box
        sx={{
          width: '100%',
          height: '65vh',
          border: '1px solid black',
          mb: 3,
          [theme.breakpoints.up('md')]: {
            height: '80vh'
          }
        }}
        component='iframe'
        src={termsOfUse?.file}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <LoadingButton sx={{ mr: 2 }} onClick={onExit} loading={isLoading}>
          {formatMessage({
            id: 'termsOfUse.exit',
            defaultMessage: 'Odrzuć'
          })}
        </LoadingButton>
        <LoadingButton variant='contained' color='primary' loading={isLoading} onClick={onAccept}>
          {formatMessage({
            id: 'termsOfUse.accept',
            defaultMessage: 'Akceptuje'
          })}
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default TermsOfUseForm
